import {Injectable} from '@angular/core';
import {ConfirmationDialogComponent} from '@app/component/confirmation-dialog/confirmation-dialog.component';
import {MatDialog, MatDialogRef} from '@angular/material';


@Injectable()
export class DialogService {

  constructor(private dialog: MatDialog) {
  }

  public confirm(title: string, message: string) {
    let dialogRef: MatDialogRef<ConfirmationDialogComponent>;

    dialogRef = this.dialog.open(ConfirmationDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;

    return dialogRef.afterClosed();

  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/core/services/dialog.service.ts